/** @jsxRuntime classic */
/** @jsx jsx */
import { Fragment } from 'react'
import { jsx } from 'theme-ui'

import { FollowUsButtonsStyled, FollowUsButtonsListStyled, FollowUsButtonsListItemStyled, FollowUsButtonsLinkStyled } from './styles'
import { Social } from '../../../enums/socials'
import {
  IconFollowFacebook,
  IconFollowInstagram,
  IconFollowYoutube,
  IconFollowTwitter,
  IconFollowTelegram,
  IconFollowLinkedin,
  IconFollowTikTok
} from './../../../assets/svg/index'
import { FollowUsButtonsProps } from './types'

const FollowUsButtons: React.FC<FollowUsButtonsProps> = ({ data, isSmall }) => {
  return (
    <FollowUsButtonsStyled {...{ isSmall }}>
      <FollowUsButtonsListStyled>
        {data.map(({ key, label, url }) => (
          <Fragment {...{ key }}>
            {url && (
              <FollowUsButtonsListItemStyled>
                <FollowUsButtonsLinkStyled title={url} href={url}>
                  {label === Social.Facebook ? <IconFollowFacebook /> : ''}
                  {label === Social.Twitter ? <IconFollowTwitter /> : ''}
                  {label === Social.Youtube ? <IconFollowYoutube /> : ''}
                  {label === Social.Instagram ? <IconFollowInstagram /> : ''}
                  {label === Social.Telegram ? <IconFollowTelegram /> : ''}
                  {label === Social.Linkedin ? <IconFollowLinkedin /> : ''}
                  {label === Social.TikTok ? <IconFollowTikTok /> : ''}
                </FollowUsButtonsLinkStyled>
              </FollowUsButtonsListItemStyled>
            )}
          </Fragment>
        ))}
      </FollowUsButtonsListStyled>
    </FollowUsButtonsStyled>
  )
}

export default FollowUsButtons
